import { useWindowDimensions } from './useWindowDimensions';

export const mobileMaxWidth = 768;

export function useIsMobile(): boolean {
  return useWindowDimensions().width <= mobileMaxWidth;
}
